import { executeServiceCall } from "./requests";

export const noticeService = {
  async getAllNotices(token: string): Promise<Notice[] | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.NoticeService.GetAllNotices";
    let payload = JSON.stringify({});
    return await executeServiceCall(path, payload, token);
  },
  async archiveNotice(notice: Notice, token: string): Promise<string | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.NoticeService.ArchiveNotice";
    let payload = JSON.stringify({ clientData: notice });
    return await executeServiceCall(path, payload, token);
  },
  async unArchiveNotice(notice: Notice, token: string): Promise<string | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.NoticeService.UnArchiveNotice";
    let payload = JSON.stringify({ clientData: notice });
    return await executeServiceCall(path, payload, token);
  },
  async updateNotice(notice: Notice, token: string): Promise<string | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.NoticeService.UpdateNotice";
    let payload = JSON.stringify({ clientData: notice });
    return await executeServiceCall(path, payload, token);
  },
  async addNotice(notice: Notice, token: string): Promise<string | null | undefined> {
    let path = "./services/FormidableDesigns.Services.V1.NoticeService.AddNotice";
    let payload = JSON.stringify({ clientData: notice });
    return await executeServiceCall(path, payload, token);
  }
};

export interface Notice {
  id: string | undefined;
  title: string | undefined;
  description: string | undefined;
  important: boolean | undefined;
  effectiveDate: Date | undefined;
  created: Date | undefined;
  createdBy: string | null | undefined;
  updated: Date | null | undefined;
  updatedBy: string | null | undefined;
  archivedDate: Date | null | undefined;
}

